import { injectable } from "tsyringe";
import { autoBind } from "src/shared/decorators/autobind";

@injectable()
export class PaymentsStorageService {
    public readonly KEY_REDIRECT = "hashRedirect";

    @autoBind
    saveHashRedirect(hash: string) {
        sessionStorage.setItem(this.KEY_REDIRECT, hash);
    }

    @autoBind
    removeHashRedirect() {
        sessionStorage.removeItem(this.KEY_REDIRECT);
    }
}
